import React, { useMemo } from 'react';
import { useAppFilters } from '@/hooks/shared';
import { AssetOverview } from './AssetOverview/AssetOverview';
import { Asset } from '@/types/models/assets.types';
import { useActiveAssetsType } from '@/hooks/shared/useActiveAssetsType';
import { ObservationsAndActions } from './ObservationsAndActions/ObservationsAndActions';
import { RootState } from '@/store/store';
import { useSelector, useDispatch } from 'react-redux';
import { Top20AlarmsChartCard } from '../../shared/Top20AlarmsChartCard';
import { HEALTH_STATUS } from '@/types';
import { FusionTrendCard } from './FusionTrend/FusionTrendCard';
import { EventsDashboard } from './EventsDashboard';
import { BaseButton } from '@/components/uiKit/Button';
import { BaseTooltip } from '@/components';
import { ToggleLeft, ToggleRight } from 'lucide-react';
import { toggleUseFaultsField } from '@/store/slices/assetStudioSlice';

interface DiagnosticsProps {
  components: any[];
  asset: Asset;
  diagnostics: any[];
  isLoading: boolean;
  isLeftPanelCollapsed?: boolean;
}

export const Diagnostics = ({ components, asset, diagnostics, isLoading, isLeftPanelCollapsed }: DiagnosticsProps) => {
  const { selectedComponent } = useAppFilters();
  const dispatch = useDispatch();

  const { showAlarms } = useSelector((state: RootState) => state.alarms);
  const { selectedDiagnostic, useFaultsField } = useSelector((state: RootState) => state.assetsStudio);
  const { isMobileAsset } = useActiveAssetsType();
  const isComponentNotHealthy = useMemo(
    () =>
      selectedDiagnostic?.[1]?.assets?.[0]?.components.find((el: any) => el.component_id === selectedComponent)
        ?.health_status !== HEALTH_STATUS.HEALTHY,
    [selectedDiagnostic, selectedComponent]
  );

  const assetName = useMemo(() => {
    const item = components?.find((el: any) => el.component_id === selectedComponent);
    return item?.unit_ui_name && (item?.component_ui_name || item?.component_name)
      ? `${item.unit_ui_name} - ${item.component_ui_name || item.component_name}`
      : item?.component_ui_name || item?.component_name || asset?.asset_ui_name;
  }, [selectedComponent, components]);

  return (
    <>
      {/* Floating Toggle Button - Removed for production */}
      {/* <div className="fixed bottom-4 right-4 z-50">
        <BaseTooltip 
          content={`Using ${useFaultsField ? 'New Faults Field' : 'Old Diagnostics'} Implementation`}
        >
          <BaseButton
            variant="outline"
            size="sm"
            className="bg-white shadow-lg hover:shadow-xl transition-shadow flex items-center gap-2"
            onClick={() => dispatch(toggleUseFaultsField())}
          >
            {useFaultsField ? (
              <ToggleRight className="h-5 w-5 text-green-600" />
            ) : (
              <ToggleLeft className="h-5 w-5 text-gray-600" />
            )}
            <span className="text-xs font-medium">
              {useFaultsField ? 'Faults' : 'Diagnostics'}
            </span>
          </BaseButton>
        </BaseTooltip>
      </div> */}

      <div className="flex flex-col flex-1 gap-4 min-h-0 w-full overflow-auto no-scrollbar">
        <FusionTrendCard assetName={assetName} diagnostics={diagnostics} isLoading={isLoading} />

        {/* {assetsType !== ASSETS_TYPE.FIXED && (
          <div className="flex flex-col h-full gap-2 w-1/5">
            <LifeSpan />
          </div>
        )} */}
        {/* </div> */}
        {isMobileAsset ? (
          <>
            {/* {selectedComponent !== 'all-components' && isComponentNotHealthy && ( */}
            <div className="flex flex-row flex-1 min-h-[400px] gap-4">
              <div className="w-3/5">
                <ObservationsAndActions isLoading={isLoading} asset={asset} />
              </div>
              <div className="w-2/5">
                <EventsDashboard isLoading={isLoading} />
              </div>
            </div>
            {/* )} */}

            {/* Hide Top20AlarmsChartCard in Site Level Faults List - Phase 1 */}
            {/* {showAlarms && (
            <div className="h-[200px]">
              <Top20AlarmsChartCard
                isLoading={isLoading}
                title={
                  selectedComponent !== 'all-components' ? assetName + ' alarms' : 'Total Asset Alarms By Component'
                }
              />
            </div>
          )} */}
          </>
        ) : (
          <div className="w-full flex-col flex-1 min-h-0">
            <AssetOverview
              assetName={assetName}
              components={components}
              isLoading={isLoading}
              diagnostics={diagnostics}
            />
          </div>
        )}
      </div>
    </>
  );
};
